import { defaultEmailPreferences } from 'utils/contentProvider';

export const user = ({ user: u }) => ({
  notificationSound: true,
  ...u,
  emailPreferences: { ...defaultEmailPreferences, ...u?.emailPreferences },
});
